<template>
<div class="chapter">
<div class="inner_page">
<p class="copy2" id="copyright"><a id="page_iv">This publication received generous support from the Stephen M. Silberstein Foundation.</a></p><a id="page_iv">
<p class="copy">Poem “My Teacher” © Alice Walker, excerpted with permission of Alice Walker.</p>
</a><p class="copy"><a id="page_iv">© 2018 by the University of Georgia Press<br/>Athens, Georgia 30602<br/></a><a href="http://www.ugapress.org" target="_blank">www.ugapress.org</a><br/>Foreword © 2018 by Alice Walker<br/>Spelman Diary © 1963 the Howard Zinn Revocable Trust<br/>All rights reserved<br/>Designed by Melissa Bugbee Buchanan<br/>Set in Minion Pro and Myriad Pro<br/>Printed and bound by<br/>The paper in this book meets the guidelines for permanence and durability of the Committee on Production Guidelines for Book Longevity of the Council on Library Resources.</p>
<p class="copy">Most University of Georgia Press titles are available from popular e-book vendors.</p>
<p class="copy">Printed in the United States of America<br/>22 21 20 19 18 P 5 4 3 2 1</p>
<p class="copy">Library of Congress Cataloging-in-Publication Data</p>
<p class="copy">Names: Zinn, Howard, 1922–2010, author. | Cohen, Robert, 1955 May 21–editor, writer of added commentary. | Walker, Alice, 1944–writer of foreword.<br/>Title: Howard Zinn’s Southern diary : sit-ins, civil rights, and black women’s student activism / Robert Cohen ; foreword by Alice Walker.<br/>Description: Athens : The University of Georgia Press, [2018] | Includes bibliographical references and index.<br/>Identifiers: LCCN 2017059453| ISBN 9780820353227 (hardcover : alk. paper) | ISBN 9780820353289 (pbk. : alk. paper) | ISBN 9780820353234 (ebook)<br/>Subjects: LCSH: Zinn, Howard, 1922–2010—Diaries. | Spelman College—History. | Southern States—Race relations—History—20th century.<br/>Classification: LCC PS3576.I538 Z46 2018 | DDC 818/.5403 [B]—dc23<br/>LC record available at <a href="https://lccn.loc.gov/2017059453" target="_blank">https://lccn.loc.gov/2017059453</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?076763c3